<template>
<div id="navbar">
        <div class="style-page">
        <div class="wrappers">

            <div class="conf-button">
                <span class="fa fa-bed" style="color:#ff6600;"></span>
                <h6>Book now</h6>
            </div>
            <p>booking button content</p>
        </div>
    </div>
    <header class="color-1 hovered menu-3">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav">
                        <a href="/" class="logo">
                            <img src="/static/img/logo_dark1.png" alt="Hostal Pelikan">
                        </a>
                        <div class="nav-menu-icon">
                            <a href="#">
                                <i></i>
                            </a>
                        </div>
                        <nav class="menu">
                            <ul>
                                <li class="type-1 active">
                                    <router-link to="/">Home</router-link>
                                </li>
                                <li class="type-1">
                                    <a href="#">Nosotros
                                        <span class="fa fa-angle-down"></span>
                                    </a>
                                    <ul class="dropmenu">
                                        <li>
                                            <router-link active-class="active" to="/contact">111</router-link>
                                        </li>
                                        <li>
                                            <a href="#">Mission</a>
                                        </li>
                                    </ul>

                                </li>
                                <li class="type-1">
                                    <a href="#">Habitaciones
                                        <span class="fa fa-angle-down" style="color: red;"></span>
                                    </a>
                                    <ul class="dropmenu">
                                        <li>
                                            <a href="#">Para familia</a>
                                        </li>
                                        <li>
                                            <a href="">Para tener familia</a>
                                        </li>

                                    </ul>
                                </li>

                                <li class="type-1">
                                    <a href="#">Services
                                        <span class="fa fa-angle-down"></span>
                                    </a>
                                    <ul class="dropmenu">
                                        <li>
                                            <a href="">Something</a>
                                        </li>

                                    </ul>
                                </li>

                                <li class="type-1">
                                    <a href="#">Contacto
                                        <span class="fa fa-angle-down"></span>
                                    </a>

                                </li>
                                <li style="type-1" > <!-- >style="margin-bottom: 5px;"> -->

                                    <span class="btn btn-default" style="border-radius: 25px;    font-weight: 700;border-color: #ff6600; background: none !important;">
                                        <i class="fa fa-phone" style="color:#ff6600"></i>
                                        <span style="color: black;">&nbsp;+57 (5) 4 219057</span>
                                    </span>

                                </li>
                            </ul>

                        </nav>

                    </div>


                </div>
            </div>
        </div>
    </header>

</div>
    
</template>

<script>
export default {
  methods: {
  },
  computed: {
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: 'Hello World!'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Navbar.vue?2619cfe0